import type { AnyAction, Store } from 'redux';
import { mirrorQueriesToRedux } from '@/services/query';
import { companyCapabilitiesMirror } from '@/domain/companies/queries/capabilitiesMirror';

// Every query whose answer Redux still holds for its readers; a mirror leaves the list with its last Redux reader.
const queryReduxMirrorsInitializer = (store: Pick<Store<unknown, AnyAction>, 'getState' | 'dispatch'>) =>
  mirrorQueriesToRedux(store, [companyCapabilitiesMirror]);

export default queryReduxMirrorsInitializer;
